export const isPlanCancellationFeeLoadingSelector = (state) => state.planCancellationFee.isLoading;
export const planCancellationFeeSelector = (state) => state.planCancellationFee.data;
//# sourceMappingURL=selectors.js.map